import { inject, Injectable } from '@angular/core';
import { ApiDependencyProviderService } from '@web/common';
import { map, Observable } from 'rxjs';
import { blank, valueOrDefault } from '@web/utils';
import { AdminRefundSettingsResponse } from '../responses/admin-refund-settings.response';
import { AdminRefundSettingsUpdateRequest } from '../requests/admin-refund-settings-update.request';

@Injectable({
  providedIn: 'root',
})
export class AdminRefundSettingsApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchSettings(options: {
    skipByLoading?: boolean;
  }): Observable<AdminRefundSettingsResponse> {
    const path = 'admin/settings/refund';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .withOptionalSkipByLoadingInterceptor(() =>
        valueOrDefault(options?.skipByLoading, false),
      )
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToResponse(AdminRefundSettingsResponse),
        ),
      );
  }

  public updateSettings(
    request: AdminRefundSettingsUpdateRequest,
  ): Observable<void> {
    const path = 'admin/settings/refund';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const body = this.provider.httpHelper.requestToBody(
      request,
      AdminRefundSettingsUpdateRequest,
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .build();

    return this.provider.http.put(url, body, { context }).pipe(blank());
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
